<template>
    <span data-store-recommend>
        <div class="goods-detail-item" v-if="commendArray.length">
            <div class="guess-tittle">
                <ul>
                    <li @click="bindSelect(1)" :class="{'checked':showIndex == 1}" data-name="为你推荐">သင့္အတြက္</li>
                    <li @click="bindSelect(2)" :class="{'checked':showIndex == 2}" data-name="排行榜">ေရာင္းအေကာင္းဆံုး</li>
                </ul>
            </div>
            <div :style="{width:winW+'px'}" class="guess-swipe" ref="swipe" v-show="showIndex == 1 ">
                <ul class="guess-goods J-scroll-exclude" :style="{width:(winW * commendArray.length )  +'px'}" key="tab-1">
                    <li v-for="(itemLi,indexLi) in commendArray" :style="{width:winW+'px'}" :class="{'J-scroll-exclude':groupLength > 1 }">
                        <dl v-for="(itemDl , indexDl )  in itemLi" @click="bindNavigateToGoodsDetail(itemDl.commonId)" :class="{'J-scroll-exclude':groupLength > 1 }">
                            <dt><img :src="itemDl.imageSrc | ncImage" :class="{'J-scroll-exclude':groupLength > 1 }" @click="bindNavigateToGoodsDetail(itemDl.commonId)"></dt>
                            <dd :class="['goods-name' ,{'J-scroll-exclude':groupLength > 1 }]">{{itemDl.goodsName}}</dd>
                            <dd :class="['goods-price' ,{'J-scroll-exclude':groupLength > 1 }]">Ks<em class="J-scroll-exclude">{{itemDl.appPrice0 | priceFormat}}</em></dd>
                        </dl>
                    </li>
                </ul>
                <div class="bx-pager" v-if="groupLength != 1">
                    <span v-for="index in groupLength"
                          :class="[{active:currentPage ==index },'bx-pager-item'] " @click="core(index)"></span>
                </div>
            </div>

            <div v-show="showIndex == 2 " class="guess-swipe">
                <ul class="guess-goods" key="tab-2">
                    <li>
                        <dl class="scroll-exclude" v-for="(itemDl , indexDl )  in storeRankingsList"
                            @click="bindNavigateToGoodsDetail(itemDl.commonId)">
                            <dt><img :src="itemDl.imageSrc | ncImage"></dt>
                            <dd class="goods-name">{{itemDl.goodsName}}</dd>
                            <dd class="goods-price">Ks<em>{{itemDl|getPrice}}</em></dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </div>

        <div v-else class="goods-detail-item">
            <div class="guess-tittle">
                <ul>
                    <li  class="checked" data-name="排行榜">ေရာင္းအေကာင္းဆံုး</li>
                </ul>
            </div>
            <div class="guess-swipe">
                <ul class="guess-goods">
                    <li>
                        <dl class="scroll-exclude" v-for="(itemDl , indexDl )  in storeRankingsList"
                            @click="bindNavigateToGoodsDetail(itemDl.commonId)">
                            <dt><img :src="itemDl.imageSrc | ncImage" class=""></dt>
                            <dd class="goods-name ">{{itemDl.goodsName}}</dd>
                            <dd class="goods-price ">Ks<em>{{itemDl|getPrice}}</em></dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </div>
     </span>

</template>
<script>
  /**
   * 商品详情页中的店铺详情
   */
  var swipeIscrollInstance;
  export default {
    //外部传入参数
    props: {
      //店铺排行
      storeRankingsList: {
        type: Array,
        required: true
      },
      //店铺为你推荐
      storeCommendList: {
        type: Array,
        required: true
      }
    },
    /*
     * 自身数据,一定要一个function
     */
    data() {
      return {
        groupLength: 0,
        showIndex: 1,
        //屏幕宽度
        winW: 375,
        currentPage: 0
      }
    },
    /**
     * 计算属性
     */
    computed: {
      //显示用的店铺推荐列表，拆分成6个一组
      commendArray: function () {
        var _commend = this.storeCommendList,
          length = _commend.length,
          result = []
        ;
        if (length > 0) {
          for (var i = 0; i < length; i += 6) {
            result.push(_commend.slice(i, i + 6));
          }
          this.groupLength = result.length;
          result.push(result[0])
          result.unshift(result[this.groupLength - 1])
        }
        console.log(_commend);
        return result;
      } ,
      /**
       * 标识商品推荐不需要滚动条
       */
      noIscroll : function () {
        return this.groupLength <= 6
      }
    },
    /**
     * 过滤器
     */
    filters: {
      //获取价格
      getPrice: function (value) {
        return getPrice0(value)
      },
      priceFormat: function (value) {
        return Nc.priceFormat(value);
      },
      ncImage: function (value) {
        return ncImage(value, 240, 240);
      }
    },
    mounted() {
      var self = this
      this.computRect()
      $(window).resize(function () {
        self.computRect()
      });
      this.$nextTick(function () {
        if (this.groupLength <=1) {
          return
        }
        swipeIscrollInstance = new IScroll(this.$refs.swipe, {
          scrollX: true,
          scrollY: false,
          momentum: false,
          snap: true,
          snapSpeed: 500,
          click: true,
          bounce: true,
          snapCallBack: function (pageX, pageY) {

            if (pageX == 0) {
              self.currentPage = self.commendArray - 1;
            } else if (pageX > self.commendArray) {
              self.currentPage = 1
            } else {
              self.currentPage = pageX
            }
//                      console.log(self.currentPage+""+pageX+"####"+this.index);
          }
        });
        swipeIscrollInstance.goToPage(1, 0, 0)
        swipeIscrollInstance.on("scrollEnd", function () {
          var _pageX = swipeIscrollInstance.currentPage.pageX;

          if (_pageX == 0) {

            swipeIscrollInstance && swipeIscrollInstance.goToPage(self.commendArray.length - 2, 0, 0)
          }
          if (_pageX == self.commendArray.length - 1) {
            swipeIscrollInstance.goToPage(1, 0, 0)
          }
        })
      })

    },
    /**
     * 自定义方法
     */
    methods: {
      // 计算宽高
      core(index){
        console.log(index);
      },
      computRect: function () {
        //屏幕宽度
        this.winW = $(window).width();
      },
      //点击跳转到商品详情
      bindNavigateToGoodsDetail: function (commonId) {
        console.log("store-recommend -> 点击跳转到商品详情",commonId)
        this.$emit("godetail", commonId)
      } ,
      bindSelect:function (index) {
        this.showIndex = index ;
        this.$emit("refresh")
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/goods-store-recommend/goods-store-recommend.vue